import { Injectable } from '@angular/core';
import { BreadCrumb } from '../models/breadcrumb.model';

@Injectable({
    providedIn: 'root'
})
export class BreadcrumbsService {
    public crumbs: BreadCrumb[] = [];
}
